var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	980778: {
		fallback: () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(331), __webpack_require__.e(225), __webpack_require__.e(887), __webpack_require__.e(198), __webpack_require__.e(239), __webpack_require__.e(868), __webpack_require__.e(402), __webpack_require__.e(627), __webpack_require__.e(504), __webpack_require__.e(845), __webpack_require__.e(952), __webpack_require__.e(618), __webpack_require__.e(944), __webpack_require__.e(764), __webpack_require__.e(614), __webpack_require__.e(423)]).then(() => (() => (__webpack_require__(287561))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	356070: {
		fallback: () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(331), __webpack_require__.e(225), __webpack_require__.e(887), __webpack_require__.e(198), __webpack_require__.e(239), __webpack_require__.e(868), __webpack_require__.e(402), __webpack_require__.e(627), __webpack_require__.e(504), __webpack_require__.e(845), __webpack_require__.e(952), __webpack_require__.e(618), __webpack_require__.e(944), __webpack_require__.e(764), __webpack_require__.e(614), __webpack_require__.e(423)]).then(() => (() => (__webpack_require__(241752))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "17.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	737871: {
		fallback: () => (Promise.all([__webpack_require__.e(385), __webpack_require__.e(331), __webpack_require__.e(225), __webpack_require__.e(887), __webpack_require__.e(198), __webpack_require__.e(239), __webpack_require__.e(868), __webpack_require__.e(402), __webpack_require__.e(627), __webpack_require__.e(504), __webpack_require__.e(845), __webpack_require__.e(952), __webpack_require__.e(618), __webpack_require__.e(944), __webpack_require__.e(764), __webpack_require__.e(614), __webpack_require__.e(423)]).then(() => (() => (__webpack_require__(979859))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "5.3.11",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-components",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"62": [
		356070,
		737871
	],
	"540": [
		980778
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}